import { render, staticRenderFns } from "./NewsCardComponent.vue?vue&type=template&id=68e738c8&scoped=true&"
import script from "./NewsCardComponent.vue?vue&type=script&lang=ts&"
export * from "./NewsCardComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e738c8",
  null
  
)

export default component.exports